import React, { useEffect, useState } from 'react';
import './FashionOrbitLoader.css';

export interface FashionOrbitLoaderProps {
    stage?: 'avatar' | 'video' | 'outfit' | 'fast-mode';
}

const MESSAGE_TIMELINES = {
    avatar: [
        { time: 0, msg: "Yüz hatları ve cilt tonu analiz ediliyor..." },
        { time: 4000, msg: "Yüz geometrisi haritalanıyor ve 3D model oluşturuluyor..." },
        { time: 8000, msg: "Mimikler ve detaylar işleniyor, dijital ikiziniz hazırlanıyor..." },
        { time: 15000, msg: "Son kontroller yapılıyor..." }
    ],
    video: [
        { time: 0, msg: "Stiliniz analiz ediliyor ve dijital podyum hazırlanıyor... (Tahmini 45 sn)" },
        { time: 15000, msg: "Kumaş fiziği ve doku detayları en yüksek çözünürlüğe optimize ediliyor. Kusursuz sonuçlar biraz zaman alabilir ama beklemeye değer." },
        { time: 35000, msg: "Son rötuşlar yapılıyor; ışık ve gölge ayarları podyum standartlarına getiriliyor. Neredeyse hazır!" },
        { time: 60000, msg: "Yoğunluk nedeniyle biraz daha vaktinizi alacağız, stiliniz üzerinde titizlikle çalışıyoruz..." }
    ],
    outfit: [
        { time: 0, msg: "Kıyafet dokusu ve fiziksel özellikleri analiz ediliyor..." },
        { time: 5000, msg: "Vücut ölçüleri ile kumaş eşleştiriliyor..." },
        { time: 10000, msg: "Drape ve ışık hesaplamaları yapılıyor..." }
    ],
    'fast-mode': [
        { time: 0, msg: "Analyzing style profile..." },
        { time: 3000, msg: "Generating podyum-ready avatar..." },
        { time: 6000, msg: "Applying fabric physics..." }
    ]
};

export const FashionOrbitLoader: React.FC<FashionOrbitLoaderProps> = ({ stage = 'video' }) => {
    const timelines = MESSAGE_TIMELINES[stage] || MESSAGE_TIMELINES['video'];
    const [message, setMessage] = useState(timelines[0].msg);

    useEffect(() => {
        // Reset message when stage changes
        setMessage(timelines[0].msg);

        const timeouts: NodeJS.Timeout[] = [];

        timelines.forEach(({ time, msg }) => {
            if (time > 0) {
                const timeout = setTimeout(() => {
                    setMessage(msg);
                }, time);
                timeouts.push(timeout);
            }
        });

        return () => {
            timeouts.forEach(clearTimeout);
        };
    }, [stage, timelines]);

    return (
        <div className="fashion-orbit-loader-container">
            <div className="fashion-orbit-center">
                <div className="fashion-orbit-logo">F</div>
                <div className="fashion-orbit-ring ring-1"></div>
                <div className="fashion-orbit-ring ring-2"></div>
                <div className="fashion-orbit-ring ring-3"></div>
                <div className="fashion-orbit-particle particle-1"></div>
                <div className="fashion-orbit-particle particle-2"></div>
            </div>

            <div className="fashion-orbit-message-container">
                <p className="fashion-orbit-message">{message}</p>
                <div className="fashion-orbit-progress-bar">
                    <div className="fashion-orbit-progress-fill"></div>
                </div>
            </div>
        </div>
    );
};
